export const PATTERNS = {
  SUB_DOMAIN: /(?:[\s.])([a-z0-9][a-z0-9-]+[a-z0-9]\.auperator\.co)/,
  SUB_DOMAIN_STRING: /^[a-z0-9_-]+$/,
  // tslint:disable-next-line:max-line-length
  EMAIL: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  EMAIL_EXCLUDE_ESHOPBOX: /^(?!.*@eshopbox\.com)(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  PHONE: /^[1-9]{1}[0-9]{9}$/,
  PAN_CARD: /^([A-Za-z]){5}([0-9]){4}([A-Za-z]){1}?$/,
  SLUG: /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9]$/,
  //   PASSWORD: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/
  PASSWORD: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])[A-Za-z\d!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{3,}$/,
  PINCODE: /^[1-9][0-9]{5}$/,
  NUMBER: /^[0-9]*$/,
  NUMBERDECIMAL: /^\d{1,5}$|(?=^.{1,5}$)^\d+\.\d{0,2}$/,
  STRING: /^[A-Za-z]/,
  URL: /\./,
  IFSC: /^[A-Za-z]{4}0[A-Z0-9a-z]{6}$/,
  GSTIN: /^([0][1-9]|[1-2][0-9]|[3][0-7])([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$/,
  AADHARCARD: /^[2-9]{1}[0-9]{11}$/,
  BANK_ACCOUNT_NUMBER: /^[0-9]{9,18}$/
};

export const VALIDATION_MESSAGES = {
  fullName: [{ type: 'required', message: 'Enter Your Full Name' }],
  firstName: [{ type: 'required', message: 'Enter First Name' }],
  lastName: [{ type: 'required', message: 'Enter Last Name' }],
  email: [
    { type: 'required', message: 'This is required' },
    { type: 'pattern', message: 'Enter a valid Email address' }
  ],
  user: [
  { type: 'required', message: 'This is required' },
  { type: 'pattern', message: 'Enter a valid Email address' }
],
  phoneNumber: [
    { type: 'required', message: 'Enter a Phone Number' },
    { type: 'pattern', message: 'Please enter 10 digit phone number.' }
  ],
  confirmPassword: [
    { type: 'required', message: 'Enter a Confirm password' },
    { type: 'notEqual', message: 'The password does not match' }
  ],
  password: [
    { type: 'required', message: 'Enter a Password' },
    {
      type: 'minlength',
      message: 'The password length should be atleast 8 characters long'
    },
    {
      type: 'pattern',
      message: 'Kindly use combination of Alphanumeric and special characters'
    }
  ]
}

export const statusValues = {
  active: [1,2,3,4,5,6,7,8,9,10,11,12,19,20,21,22,23],
  Exception : [-1,15,16,99],
  Pending : [0,24,101,102]
}


export const staticStatusList = {
  statusList : [
  { value: 'Inactive', label: 'Inactive' },
  { value: 'Active', label: 'Active' },
  { value: 'Draft', label: 'Draft' },
  { value: 'Spare', label: 'Spare' },
  { value: 'InUse', label: 'InUse' },
  { value: 'Idle', label: 'Idle' },
  { value: 'Retired', label: 'Retired' },
  { value: 'Damaged', label: 'Damaged' },
  { value: 'InRepair', label: 'InRepair' },
  { value: 'Lost', label: 'Lost' },
  { value: 'Running', label: 'Running' },
  { value: 'Parked', label: 'Parked' },
  { value: 'Broken', label: 'Broken' },
  { value: 'New', label: 'New' },
  { value: 'Live', label: 'Live' },
  { value: 'Past', label: 'Past' },
  { value: 'Expired', label: 'Expired' }
]
}
